import {
  inject,
  ref,
  isRef,
  watch,
  onMounted,
  onUnmounted
} from 'vue'

export const addWidget = (connector, parent, widgetParams, render) => {
  const factory = connector(render)
  const widget = factory(widgetParams)
  parent.addWidgets([widget])

  return widget
}

export const forceRender = (widget, parent, instantSearchInstance) => {
  if (
    instantSearchInstance.__initialSearchResults
    && !instantSearchInstance.started
  ) {
    if (typeof instantSearchInstance.__forceRender !== 'function') {
      throw new Error(
        'You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.'
      )
    }
    instantSearchInstance.__forceRender(widget, parent)
  }
}

export const removeWidget = (widget, parent) => {
  if (widget) {
    parent.removeWidgets([widget])
  }
}

export function useConnector (connector, props, { skipFirstRender = true } = {}) {
  const instantSearchInstance = inject('$_ais_instantSearchInstance', null)

  const state = ref(null)

  // Not inside an InstantSearch provider — return empty state.
  // This happens on the first render of pages that set instantSearchProps in setup;
  // the component re-renders inside InstantSearch on the next tick.
  if (!instantSearchInstance) return state

  const parent = inject('$_ais_getParentIndex', () => instantSearchInstance.value?.mainIndex || instantSearchInstance.mainIndex)()

  let widget

  const render = (newState, isFirstRender) => {
    if (skipFirstRender && isFirstRender) return

    const copy = Object.assign({}, newState)
    delete copy.widgetParams
    state.value = copy
  }

  const updateWidget = () => {
    removeWidget(widget, parent)
    state.value = null
    widget = addWidget(connector, parent, props.value, render)
  }

  onMounted(() => {
    widget = addWidget(
      connector,
      parent,
      isRef(props) ? props.value : props,
      render
    )
    forceRender(widget, parent, instantSearchInstance)
  })

  onUnmounted(() => {
    removeWidget(widget, parent)
    widget = null
  })

  if (isRef(props)) {
    watch(props, updateWidget)
  }

  return state
}
